import { categories } from "@/mocks/categories";

export default function CategoriesGrid() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Popular Categories
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            One-click jump to your favorite product list — curated and updated weekly
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-200 cursor-pointer overflow-hidden"
            >
              <div className="w-full h-32 md:h-36 relative overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name.replace(/&amp;/g, "&")} category — AllChinaBuy Spreadsheet products`}
                  title={`AllChinaBuy Spreadsheet ${cat.name.replace(/&amp;/g, "&")} — Verified Products`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
              </div>
              <div className="flex flex-col items-center gap-2 p-3 md:p-4">
                <span
                  className="text-xs md:text-sm font-medium text-foreground-700 text-center leading-tight group-hover:text-foreground-900 transition-colors duration-200"
                  dangerouslySetInnerHTML={{ __html: cat.name }}
                ></span>
                <span className="text-[10px] text-accent-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                  View Products →
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-xs text-foreground-400">
            All category links open on kaspreadsheet.com — carefully curated product lists
          </p>
        </div>
      </div>
    </section>
  );
}